module.exports = __webpack_public_path__ + "fbff1f76d71202fe93de0bf356def2da.jpg";